  <template>
    <b-modal
      no-close-on-backdrop
      centered
      ok-only
      size="lg"
      ok-title="Fechar"
      ok-variant="danger"
      v-model="open"
      :title="title"
      :busy="loading"
    >
      <b-row v-if="loading">
        <b-col cols="12" class="text-center">
          <b-spinner label="Spinning"></b-spinner>
        </b-col>
      </b-row>
      <b-row v-else class="container">
        <b-col cols="12" class="mb-4">
          <label>Cupom <span class="fs-14 c-gray-3"> (mínimo de 5 caracteres e máximo 10 caracteres)</span></label>
          <b-row>
            <b-col cols="12" lg="9" class="mb-2">
              <input
                type="text"
                maxlength="10"
                class="form-control"
                v-model="fields.coupon"
                :disabled="isUpdate"
                placeholder="Digite o cupom"
                @keyup="upperCaseText()"
              />
              <label v-if="!isValid && isUpdate" class="c-red ml-2">Cupom já existe</label>
            </b-col>
            <b-col cols="12" lg="3">
              <b-button
                :disabled="fields.coupon.length < 5"
                block
                variant="primary"
                @click="validateCoupon()"
              >Validar Cupom</b-button>
            </b-col>
          </b-row>
        </b-col>

        <b-row v-if="isValid || isUpdate" class="ml-1">
          <b-col cols="12" class="mb-4">
            <b-row >
              <b-col cols="12" lg="6">
                <b-form-checkbox @change="cleanSwitch('checkedQtd')" v-model="checkedQtd" switch >
                  Definir quantidade de cupom
                  <i
                    class="fas fa-question-circle question-tool-tips"
                    id="checkedQtd"></i>
                  <BTooltip
                    target="checkedQtd"
                    placement="right"
                    triggers="hover">
                    Defina à quantidade máxima de cupons.
                  </BTooltip>
                </b-form-checkbox>
              </b-col>
              <b-col v-if="checkedQtd" cols="12" lg="6" >
                <b-input
                  v-model="fields.quantity"
                  type="number"
                  v-mask="['##########']"
                  placeholder="Insira a quantidade de cupons disponivéis"
                />
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" lg="8" class="mb-4">
            <label>Desconto por</label>
            <i
              class="fas fa-question-circle question-tool-tips"
              id="discount"></i>
            <BTooltip
              target="discount"
              placement="right"
              triggers="hover">
              Define se o desconto do cupom, vai ser por porcentagem ou em reais.
            </BTooltip>
            <b-form-select
              v-model="fields.type"
              :options="options"
              :disabled="isUpdate"
            />
          </b-col>
          <b-col v-if="fields.type !== null" cols="12" lg="4" class="mb-4">
            <div v-if="fields.type == CouponType.MONEY">
              <label>Valor</label>
              <b-input-group prepend="R$" append=",00" class="mr-sm-2 mb-sm-0">
                <b-form-input
                  id="inline-form-input-username"
                  type="text"
                  v-mask="['#####']"
                  class="form-control"
                  :disabled="isUpdate"
                  v-model="fields.value"
                  placeholder="Digite o desconto"
                />
              </b-input-group>
            </div>
            <div v-if="fields.type == CouponType.PERCENTAGE">
              <label>Porcentagem</label>
              <b-input-group append="%" class="mr-sm-2 mb-sm-0">
                <b-form-input
                  id="inline-form-input-username"
                  type="text"
                  v-mask="['###']"
                  class="form-control"
                  :disabled="isUpdate"
                  v-model="fields.value"
                  placeholder="Digite o desconto"
                />
              </b-input-group>
            </div>
          </b-col>

          <b-col v-if="fields.type !== null && fields.type == CouponType.PERCENTAGE" cols="12">
            <b-row class="mt-3">
              <b-col cols="12" lg="6">
                <b-form-checkbox
                  @change="cleanSwitch('checkedValueMax')"
                  v-model="checkedValueMax"
                  switch
                  :disabled="isUpdate"
                >
                  Limitar valor máximo de desconto
                  <i
                    class="fas fa-question-circle question-tool-tips"
                    id="maxDiscount"></i>
                  <BTooltip
                    target="maxDiscount"
                    placement="right"
                    triggers="hover">
                    Define o valor de desconto máximo na porcentagem.
                  </BTooltip>
                </b-form-checkbox>
              </b-col>
              <b-col v-if="checkedValueMax" cols="12" lg="6" >
                <b-input-group prepend="R$" append=",00" class="mr-sm-2 mb-sm-0">
                  <b-input
                    :disabled="isUpdate"
                    v-model="fields.max_discount"
                    v-mask="['#####']"
                    placeholder="digite o valor máximo de desconto"
                  />
                </b-input-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" class="mb-4">
            <b-row class="mt-3">
              <b-col cols="12" lg="6">
                <b-form-checkbox
                  @change="cleanSwitch('checkedValueMin')"
                  v-model="checkedValueMin"
                  switch
                  :disabled="isUpdate"
                >
                  Limitar valor do pedido mínimo
                  <i
                    class="fas fa-question-circle question-tool-tips"
                    id="checkedValueMin"></i>
                  <BTooltip
                    target="checkedValueMin"
                    placement="right"
                    triggers="hover">
                    Limita o valor mínimo para aplicar o cupom a compra.
                  </BTooltip>
                </b-form-checkbox>
              </b-col>
              <b-col v-if="checkedValueMin" cols="12" lg="6">
                <b-input-group prepend="R$" append=",00" class="mr-sm-2 mb-sm-0">
                  <b-input
                    :disabled="isUpdate"
                    v-model="fields.min_order"
                    v-mask="['#####']"
                    placeholder="Digite o valor para pedido mínimo"
                  />
                </b-input-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" class="mb-4">
            <b-form-checkbox
              v-model="fields.limit_client"
              switch
              :disabled="isUpdate"
            >
              Limitar a quantidade de 1 cupom por cliente
              <i
                class="fas fa-question-circle question-tool-tips"
                id="checkedLimit"></i>
              <BTooltip
                target="checkedLimit"
                placement="right"
                triggers="hover">
                Limita o uso de apenas um cupom por usuario.
              </BTooltip>
            </b-form-checkbox>
          </b-col>
          <b-col cols="12" class="mb-4">
            <b-form-checkbox
              v-model="fields.is_app"
              switch
            >
              Somente para o App
              <i
                class="fas fa-question-circle question-tool-tips"
                id="checkedLimit"></i>
              <BTooltip
                target="checkedLimit"
                placement="right"
                triggers="hover">
                Esse cupom é valido somente para o APP.
              </BTooltip>
            </b-form-checkbox>
          </b-col>
          <b-col cols="12" class="mb-4">
            <b-form-checkbox
              @change="cleanSwitch('checkedDate')"
              v-model="checkedDate"
              switch
            >
              Limitar a data
              <i
                class="fas fa-question-circle question-tool-tips"
                id="checkedDate"></i>
              <BTooltip
                target="checkedDate"
                placement="right"
                triggers="hover">
                Define uma data para expirar o cupom.
              </BTooltip>
            </b-form-checkbox>
          </b-col>
          <b-col v-if="checkedDate" cols="12" class="mb-4">
            <label>Válido até</label>
            <b-form-datepicker
                v-model="fields.expiration_data"
                reset-button
                close-button
                today-button
                :min="minDate()"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                placeholder="Valido até"
                label-close-button="Fechar"
                label-today-button="Hoje"
                label-reset-button="Limpar"
                label-help=""
                locale="pt-BR"
              />
          </b-col>
          <b-col cols="12" class="mb-4">
            <b-button block variant="success" @click="save()">
              <span v-if="isUpdate">Atualizar cupom</span>
              <span v-else>Criar cupom</span>
            </b-button>
          </b-col>
        </b-row>
      </b-row>
    </b-modal>
  </template>

  <script>
  import makeToast from '@/mixins/makeToast';
  import CouponType from '@/enums/CouponType';
  import { mapActions, mapState } from 'vuex';

  export default {
    name: 'ModalNewCoupon',
    mixins: [makeToast],
    emits: ['createCupom', 'updateCupom', 'isValidCoupon'],

    data() {
      return {
        CouponType,
        loading: false,
        open: false,
        checkedQtd: false,
        checkedDate: false,
        checkedValueMax: false,
        checkedValueMin: false,
        isUpdate: false,
        isValid: false,
        copyCoupon: "",
        title: "",
        options: [
          { value: null, text: 'Selecione a opção de desconto' },
          { text: 'Porcentagem', value: 'percentage' },
          { text: 'Valor', value: 'money' },
        ],
        fields: {
          id:'',
          construp_user_id: '',
          coupon: '',
          type: null,
          value: '',
          quantity: '',
          limit_client: false,
          is_app: false,
          expiration_data: null,
          min_order: null,
          max_discount: null
        },
      };
    },

    computed: {
      ...mapState(['dadosUsuario']),
    },

    methods: {
      ...mapActions('shopkeeper', ['isValidCoupon']),

      toggleOpen(item = []) {
        this.open = !this.open;
        this.cleanData();
        this.isUpdate = item.data.id ? true : false;
        this.title = this.isUpdate ? "Atualizar cupom" : "Criar novo cupom";
        if(this.isUpdate) {
          Object.assign(this.fields, {
            construp_user_id: item.data.construp_user_id,
            id: item.data.id,
            coupon: item.data.coupon,
            type: item.data.type,
            value: item.data.value,
            quantity: item.data.quantity,
            expiration_data: item.data.expiration_data,
            min_order: item.data.min_order,
            max_discount: item.data.max_discount,
            limit_client: item.data.limit_client == 1 ? true : false,
            is_app: item.data.is_app == 1 ? true : false
          });
          this.checkedQtd =  item.data.quantity > 0 ? true : false;
          this.checkedDate =  item.data.expiration_data ? true : false;
          this.checkedValueMax =  item.data.max_discount ? true : false;
          this.checkedValueMin =  item.data.min_order ? true : false;
          this.copyCoupon = item.data.coupon;
          this.isValid = true
        }
      },

      cleanData() {
        this.fields.id ='';
        this.fields.construp_user_id = '';
        this.fields.coupon = '';
        this.fields.type = null;
        this.fields.value = '';
        this.fields.quantity = '';
        this.fields.expiration_data = null;
        this.fields.min_order = null;
        this.fields.max_discount = null;
        this.fields.limit_client = false;
        this.fields.is_app = false;
        this.checkedQtd = false;
        this.checkedDate = false;
        this.checkedValueMax = false;
        this.checkedValueMin = false;
        this.isUpdate = false;
        this.title = "";
        this.isValid = false;
        this.copyCoupon = "";
      },

      upperCaseText() {
        this.fields.coupon = this.fields.coupon.toUpperCase();
      },

      validateCoupon(){
        if(this.fields.coupon.length <= 4) {
          this.makeToast(
            'Erro',
            'O cupom precisa ter no mínimo 5 caracteres',
            'danger'
          );
          return
        }

        if(this.copyCoupon == this.fields.coupon) {
          this.isValid = true;
          return
        }

        const data = {
          construpUserId: this.dadosUsuario.id,
          coupon: this.fields.coupon
        }

        let existCoupon = false
        this.isValid = false;

        this.isValidCoupon(data)
          .then((response) => {
            existCoupon = response.data.data;

            if(existCoupon) {
              this.makeToast(
                'Erro',
                'Esse cupom já está em uso',
                'danger'
              );
              this.isValid = false;
              return
            }

            this.isValid = true;
          })
          .catch(() => {
            this.makeToast(
              'Erro',
              'Houve um erro ao validar o cupom',
              'danger'
            );
          })
          .finally(() => {
            this.loading = false;
          });
      },

      minDate() {
        const today = new Date().toISOString().split("T")[0];
        return today;
      },

      save() {
        if(!this.validate()) return

        if(this.isUpdate) {
          this.$emit('updateCupom', this.fields);
        }else {
          this.$emit('createCupom', this.fields);
        }

        this.open = !this.open;
      },

      validate() {
        if(this.fields.coupon.length <= 4) {
          this.makeToast(
            'Erro',
            'O cupom precisa ter no mínimo 5 caracteres',
            'danger'
          );
          return
        }

        if(this.checkedQtd && this.fields.quantity < 1) {
          this.makeToast(
            'Erro',
            'A quantidade de cupom não pode estar vazia ou zerada',
            'danger'
          );
          return false;
        }

        if(!this.fields.type){
          this.makeToast(
            'Erro',
            'Precisa selecionar uma opção para desconto',
            'danger'
          );
          return false;
        }

        if(this.fields.type == this.CouponType.PERCENTAGE){
          if(this.fields.value < 1) {
            this.makeToast(
              'Erro',
              'Favor definir a porcentagem do cupom',
              'danger'
            );
            return false;
          }

          if(this.fields.value > 100) {
            this.makeToast(
              'Erro',
              'O valor do cupom não pode ser maior que 100%',
              'danger'
            );
            return false;
          }

          if(this.checkedValueMax && this.fields.max_discount < 1) {
            this.makeToast(
              'Erro',
              'O valor máximo para desconto da porcentagem não pode estar vazio ou zerado',
              'danger'
            );
            return false;
          }
        }

        if(this.fields.type == this.CouponType.MONEY && this.fields.value < 1){
          this.makeToast(
            'Erro',
            'O valor do cupom não pode estar vazio ou zerado',
            'danger'
          );
          return false;
        }

        if(this.checkedValueMin && this.fields.min_order < 1){
          this.makeToast(
            'Erro',
            'O pedido mínimo não pode estar vazio ou zerado',
            'danger'
          );
          return false;
        }

        if(this.checkedDate && !this.fields.expiration_data){
          this.makeToast(
            'Erro',
            'Favor selecionar a data de expiração',
            'danger'
          );
          return false;
        }
        return true;
      },
      cleanSwitch(value){
        if(value == 'checkedQtd' && !this.checkedQtd) this.fields.quantity = null
        if(value == 'checkedValueMax' && !this.checkedValueMax) this.fields.max_discount = null
        if(value == 'checkedValueMin' && !this.checkedValueMin) this.fields.min_order = null
        if(value == 'checkedDate' && !this.checkedDate) this.fields.expiration_data = null
      }
    },
  };
  </script>
